import {CondensedMergeStatusWithSuspense} from '@github-ui/mergebox/components/condensed-mergeability-status'
import {Assignees} from './Assignees'
import {CondensedReviewers} from './reviewers/CondensedReviewers'
import {SidebarSection} from './SidebarSection'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'

// NOTE: this Overview info only works on the /overview page due to how its
// wired up with dataload. This is an intetional tradeoff while deciding if its worth having
// this panel at all
export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoPanel">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  const {data: layoutData} = useSuspenseRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {pullRequest, mergeStatusButtonData} = layoutData

  const prStateCanBeActionable = pullRequest.state !== 'CLOSED' && pullRequest.state !== 'MERGED'

  return (
    <div className="d-flex flex-column gap-3">
      {mergeStatusButtonData && prStateCanBeActionable && (
        <SidebarSection title="Merge status" actions={['expand']}>
          <CondensedMergeStatusWithSuspense
            headSha={mergeStatusButtonData.headSha}
            channels={mergeStatusButtonData.channels}
          />
        </SidebarSection>
      )}

      <SidebarSection title="Reviewers">
        <CondensedReviewers />
      </SidebarSection>

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>
    </div>
  )
}
